// extracted by mini-css-extract-plugin
module.exports = {"root":"ExpansionButton_root__1ckQR","iconWrapper":"ExpansionButton_iconWrapper__3l9V1","label":"ExpansionButton_label__1iUaJ","icon":"ExpansionButton_icon__3W7gt"};